module.exports = __webpack_public_path__ + "static/p3-beae7ce07db70c5675079301fab33bd8.png";